import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography, FormControl, Paper } from '@mui/material';
import moment from 'moment';
import { fetchEnvironmentImpact } from '../../../actions/environmentImpact';
import MyEnviroImpact from '../../rescuerDashboard/rescuerDashboardDesktop/myFrus/Components/MyEnviroImpact';
import DateAndGranularityPicker, { dateRangeOptionsList } 
from '../../../components/DateAndGranularityPicker/DateAndGranularityPicker';

const formatDate = (date) => moment(date).format('YYYY-MM-DD');

const SCDashboardEnvironmentImpact = ({ siteId }) => {
  const dispatch = useDispatch();
  const environmentImpact = useSelector((state) => state.entities.environmentImpact);

  const handleDateRangeChange = ({ dateRange }) => {
    if (dateRange) {
      const fromDate = formatDate(dateRange.startDate);
      const toDate = formatDate(dateRange.endDate);
      dispatch(fetchEnvironmentImpact({ sites_ids: siteId }, fromDate, toDate));
    } else {
      dispatch(fetchEnvironmentImpact({ sites_ids: siteId }));
    }
  };

  // initial fetch with default date range
  useEffect(() => {
    handleDateRangeChange({ dateRange: dateRangeOptionsList.thisQTD.range });
  }, [dispatch, siteId]);

  return (
    <Box>
      <Box mb={2}>
        <Typography variant="h6" color="textSecondary">
          Environmental Impact
        </Typography>
      </Box>

      <Paper sx={{ margin: '8px auto', padding: 2 }}>
        <FormControl variant="standard" component="fieldset">
          <DateAndGranularityPicker
            showAllDateRange
            defaultDateRange={dateRangeOptionsList.thisQTD.value}
            dateRangeOptions={{
              last7Days: dateRangeOptionsList.last7Days,
              last30Days: dateRangeOptionsList.last30Days,
              last90Days: dateRangeOptionsList.last90Days,
              thisMTD: dateRangeOptionsList.thisMTD,
              thisQTD: dateRangeOptionsList.thisQTD,
              thisYTD: dateRangeOptionsList.thisYTD,
            }}
            customDateRangeOptions={{ maxDate: new Date() }}
            showCustomDateRange
            showGranularity={false}
            isDisabled={environmentImpact.inflight}
            onChange={handleDateRangeChange}
          />
        </FormControl>
      </Paper>

      <Box display="flex" mt={2}>
        <MyEnviroImpact isLoading={environmentImpact.inflight} environmentImpact={environmentImpact.all} />
      </Box>
    </Box>
  );
};

export default SCDashboardEnvironmentImpact;
